var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Target(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 36h-9.09A22 22 0 0040 16.09V7h-4v9.09A22 22 0 0016.09 36H7v4h9.09A22 22 0 0036 59.91V69h4v-9.09A22 22 0 0059.91 40H69v-4zM40 56.34V47h-4v9.34A18.48 18.48 0 0119.66 40H29v-4h-9.34A18.48 18.48 0 0136 19.66V29h4v-9.34A18.48 18.48 0 0156.34 36H47v4h9.34A18.48 18.48 0 0140 56.34z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Target.6a8a16c0.svg";
export { SvgK1Target as ReactComponent };